// Testimonial Slider Section

class testimonalSection extends HTMLElement {
	constructor() {
		super()

		const testimonialSlider = this
		const testimonialSliderCards = this.querySelectorAll(".card_slide")
		const sliderCardsWidth = testimonialSliderCards[0].offsetWidth + 35

		const sliderBtns = this.closest(".slidercontainered").querySelectorAll(".sliderbtn")

		for (let sliderBtn of sliderBtns) {
			sliderBtn.addEventListener("click", function () {
				if (sliderBtn.getAttribute("data-id") == "right") {
					testimonialSlider.scrollLeft += sliderCardsWidth
				} else {
					testimonialSlider.scrollLeft -= sliderCardsWidth
				}
			})
		}
	}
}

customElements.define("ed-testimonial-slider", testimonalSection)